module.exports = __webpack_public_path__ + "static/img/square1.ca257073.png";